import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import VendorWithdrawServices from '../../services/VendorWithdrawServices';
import Swal from 'sweetalert2';

function VendorWithdrawlDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [withdrawData, setWithdrawData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchWithdrawDetails();
    }, [id]);

    const fetchWithdrawDetails = async () => {
        try {
            setLoading(true);

            const response = await VendorWithdrawServices.getWithdrawDetails(id);

            if (response.status) {
                setWithdrawData(response.data.withdrawal);
            }

        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    function formatDateTime(isoString) {
        if (!isoString) return '-';
        const date = new Date(isoString);
        return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    }

    function formatDateTimeFull(isoString) {
        if (!isoString) return '-';
        const date = new Date(isoString);
        return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    }
    const withdrawal = withdrawData?.withdrawal;
    const walletTransaction = withdrawData?.wallet_transaction;
    const user = withdrawal?.user_id;
    if (loading) {
        return (
            <div className="right_col" role="main">
                <div className="container">
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading withdrawal details...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!withdrawData) {
        return (
            <div className="right_col" role="main">
                <div className="container">
                    <div className="text-center py-5">
                        <p>No withdrawal data found</p>
                        <button className="btn btn-secondary" onClick={() => navigate(-1)}>
                            Go Back
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
     <div className="right_col" role="main">
            <div className="container">
                <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
                    <div className="my-auto">
                        <h5 className="page-title fs-21 mb-1"> Vendor Withdrawal Details</h5>
                    </div>
                    <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                        <button className="excel-btn" onClick={() => navigate(-1)}>
                            Back
                        </button>
                    </div>
                </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-box p-3">
                                <ul className="list-unstyled d-flex" >
                                    <li><strong>Name:</strong> {withdrawData?.user_id?.firstName || ''} {withdrawData?.user_id?.lastName || ''}</li>
                                    <li><strong>Mobile No:</strong> {withdrawData?.user_id?.mobileNo || '-'}</li>
                                    <li><strong>Email:</strong> {withdrawData?.user_id?.email || '-'}</li>
                                    <li><strong>Amount:</strong> ₹{withdrawData?.amount || 0}</li>
                                    <li><strong>Payment Method:</strong> {withdrawData?.payment_method || '-'}</li>
                                    <li><strong>UPI ID:</strong> {withdrawData?.upi_id || '-'}</li>
                                    <li><strong>UPI Name:</strong> {withdrawData?.upi_name || '-'}</li>
                                    <li><strong>Account Holder:</strong> {withdrawData?.account_holder_name || '-'}</li>
                                    <li><strong>Bank Name:</strong> {withdrawData?.bank_name || '-'}</li>
                                    <li><strong>IFSC Code:</strong> {withdrawData?.ifsc_code || '-'}</li>
                                    <li><strong>Transaction ID:</strong> {withdrawData?.transaction_id || '-'}</li>
                                    <li><strong>Payout Transaction ID:</strong> {withdrawData?.payout_transaction_id || '-'}</li>
                                    <li>
                                        <strong>Status:</strong>{' '}
                                        <span className={`badge ${
                                            withdrawData?.status?.toLowerCase() === 'approved' ? 'bg-success text-light' :
                                            withdrawData?.status?.toLowerCase() === 'rejected' ? 'bg-danger text-light' :
                                            'bg-warning '
                                        }`}>
                                            {withdrawData?.status || 'Pending'}
                                        </span>
                                    </li>
                                    <li><strong>Admin Remark:</strong> {withdrawData?.admin_remark || '-'}</li>
                                    <li><strong>Created Date:</strong> {formatDateTimeFull(withdrawData?.createdAt)}</li>
                                    <li className=''><strong>Updated Date:</strong> {formatDateTimeFull(withdrawData?.updatedAt)}</li>
                                    {withdrawData?.approved_at && (
                                        <li><strong>Approved Date:</strong> {formatDateTimeFull(withdrawData?.approved_at)}</li>
                                    )}
                                    {withdrawData?.rejected_at && (
                                        <li><strong>Rejected Date:</strong> {formatDateTimeFull(withdrawData?.rejected_at)}</li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
          
            </div>
        </div>
    );
}

export default VendorWithdrawlDetail;